import React from 'react'
import { useSelector } from 'react-redux';
import Cookies from "js-cookie";
import { CiSearch } from "react-icons/ci";
import { useTheme } from '../../Themecontext/Themecontext';

export const FilterBox = ({
    title,
    items,
    search,
    setSearch,
    selectedItems,
    toggleItem,
    selectAll,
    isMulti = true,
}) => {


    const { Colourdata } = useSelector((state) => state.ClientLogin);
    const iscolour = Colourdata?.data?.find((el) => el.ExeName === "GRAYNEW");
    const iscolourDark = Colourdata?.data?.find(
        (el) => el.ExeName === "GRAYDARKNEW",
    );

    const { theme } = useTheme();
    const isdark = theme;


    const filteredItems = items.filter(
        (item) =>
            item?.label
                ?.toLowerCase()
                .includes(search.toLowerCase())
    );

    return (
        <>

            <div
                style={{
                    // width: isBelow1024 ? "100%" : "300px",
                    maxWidth: "100%",
                    border: "1px solid rgb(183,228,199)",
                    borderRadius: "12px",
                    overflow: "hidden",
                    backgroundColor:
                        isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour10,
                    boxSizing: "border-box",
                    margin: 0,
                    padding: 0,
                }}
            >
                <div
                    style={{
                        backgroundColor:
                            isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
                        padding: "18px 22px",
                    }}
                >
                    <h3
                        style={{
                            fontWeight: "700",
                            fontSize: "18px",
                            margin: 0,
                            color:
                                isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour8,
                        }}
                    >
                        {title}
                    </h3>
                </div>



                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        padding: "12px 22px",
                    }}
                >
                    <div style={{ position: "relative", marginBottom: "12px" }}>
                        <span
                            style={{
                                position: "absolute",
                                left: "14px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                fontSize: "18px",
                                color: isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour5,
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            <CiSearch />
                        </span>

                        <>

                            <style>
                                {`
                                    .search-input::placeholder {
                                    color: ${isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1};
                                    opacity: 1;
                                    }.search-input:focus{
  border-color: ${isdark === "light"
                                        ? iscolour?.Colour1
                                        : iscolourDark?.Colour1} !important;

  box-shadow: 0 0 0 0.2rem ${isdark === "light"
                                        ? `${iscolour?.Colour1}40`
                                        : `${iscolourDark?.Colour1}40`
                                    } !important;

  outline: none !important;
}

                                    `}
                            </style>
                            <input
                                className='search-input'
                                type="text"
                                placeholder="Search..."
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                onFocus={(e) =>
                                    (e.target.style.boxShadow = "0 0 0 2px rgb(8 28 21)")
                                }
                                onBlur={(e) => (e.target.style.boxShadow = "none")}
                                style={{
                                    width: "100%",
                                    height: "44px",
                                    padding: "6px 12px 6px 42px",
                                    border: `1px solid ${isdark === "light" ? iscolour?.Colour4 : "rgb(149 213 178 / 25%)"}`,
                                    borderRadius: "10px",
                                    backgroundColor: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour7,
                                    color: "rgb(8, 28, 21)",
                                    fontSize: "15px",
                                    outline: "none",
                                    boxSizing: "border-box",
                                    color: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2
                                }}
                            />
                        </>
                    </div>

                    {isMulti ? (
                        <button onClick={selectAll}
                            className="hover-scale-btn"
                            style={{
                                width: "100%",
                                height: "48px",
                                border: "none",
                                backgroundColor: isdark === "light"
                                    ? iscolour?.Colour1
                                    : iscolourDark?.Colour1,
                                color:
                                    isdark === "light"
                                        ? iscolour?.Colour5
                                        : iscolourDark?.Colour8,
                                borderRadius: "10px",
                                fontSize: "15px",
                                cursor: "pointer",
                                marginBottom: "12px",
                                transition: "0.3s ease-in-out",
                                fontWeight: "500",
                            }}>
                            {selectedItems.length === items.length && items.length > 0
                                ? "Deselect All"
                                : "Select All"}
                        </button>
                    ) : (
                        <button onClick={selectAll}
                            className="hover-scale-btn"
                            style={{
                                width: "100%",
                                height: "48px",
                                border: "none",
                                backgroundColor: isdark === "light"
                                    ? iscolour?.Colour1
                                    : iscolourDark?.Colour1,
                                color:
                                    isdark === "light"
                                        ? iscolour?.Colour5
                                        : iscolourDark?.Colour8,
                                borderRadius: "10px",
                                fontSize: "15px",
                                cursor: "pointer",
                                marginBottom: "12px",
                                transition: "0.3s ease-in-out",
                                fontWeight: "500",
                            }}>
                            Deselect
                        </button>
                    )}

                    <div
                        className="grey-scroll"
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "8px",
                            height: "210px",
                            overflowY: "auto",
                            overflowX: "hidden",
                            paddingRight: "8px",
                            scrollbarWidth: "thin",
                            scrollbarColor: isdark === "light"
                                ? `${iscolour?.Colour1} ${iscolour?.Colour4}`
                                : `${iscolourDark?.Colour3} ${iscolourDark?.Colour7}`,
                        }}
                    >
                        {filteredItems.length > 0 ? (
                            filteredItems.map((item, index) => {
                                const isSelected = selectedItems.includes(item.value);


                                return (
                                    <div
                                        key={item.value}
                                        onClick={() => toggleItem(item)}
                                        style={{
                                            padding: "10px 12px",
                                            borderRadius: "10px",
                                            cursor: "pointer",
                                            transition: "all 0.3s ease-in-out",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            backgroundColor:
                                                isdark === "light"
                                                    ? iscolour?.Colour7
                                                    : iscolourDark?.Colour6,
                                            color:
                                                isdark === "light"
                                                    ? iscolour?.Colour2
                                                    : iscolourDark?.Colour2,
                                            border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : "rgb(149 213 178 / 25%)"}`,
                                            fontSize: "15px",
                                            fontWeight: 500,
                                            boxSizing: "border-box",
                                        }}
                                    >
                                        <span>{item.label}</span>

                                        {isSelected && (
                                            <svg
                                                style={{
                                                    height: "20px",
                                                    width: "20px",
                                                    marginLeft: "8px",
                                                    flexShrink: 0,
                                                }}
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M5 13l4 4L19 7"
                                                />
                                            </svg>
                                        )}
                                    </div>
                                );
                            })
                        ) : (
                            <p
                                style={{
                                    color: "#6b7280",
                                    fontSize: "14px",
                                    textAlign: "center",
                                    margin: 0,
                                    padding: "10px 0",
                                }}
                            >
                                No items found.
                            </p>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}


